import { Pipe, PipeTransform } from '@angular/core';
import { digger } from '@cbre/digger';
import { MiqMoment } from '@miq/utils';
import { ReportRecord } from '../../../models/report.model';

@Pipe({
  name: 'highlightDatePipe',
  standalone: false,
})
export class HighlightDatePipe implements PipeTransform {
  transform(record: ReportRecord, date: string, field: string): boolean {
    if (date && record) {
      const value = digger(record.data, field);
      const updatedDate = MiqMoment.format(value);
      const highlightDate = MiqMoment.format(date);
      return new Date(updatedDate) >= new Date(highlightDate);
    }
    return false;
  }
}
